import React from 'react';
import { injectStripe } from 'react-stripe-elements';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getFieldInitialState } from '../../../utils/helpers';
import CardSection from './CardSection';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';

const cardNameFieldName = 'card-name';

class CheckoutForm extends React.Component {
  static propTypes = {
    onLoad: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.fields = {};
  }

  state = {
    fields: {
      [cardNameFieldName]: getFieldInitialState(),
    },
    formStatus: TEXT_FIELD_STATUS.INITIAL,
    stripeCardStatus: TEXT_FIELD_STATUS.INITIAL,
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
       then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };

    let formStatus = {
      ...this.state.formStatus,
    };
    fields[name].value = value;

    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  stripeCardStatusHandler = status => (
    this.setState(({
      stripeCardStatus: status,
    }))
  )

  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  handleSubmit = (ev) => {
    ev.preventDefault();

    /* eslint-disable */
    const { value: name } = this.state.fields[cardNameFieldName];
    const { onLoad, onError, onSuccess } = this.props;
    if (this.state.stripeCardStatus === TEXT_FIELD_STATUS.VALID) {
      onLoad();
    }
     this
      .props
      .stripe
      .createToken({name})
      .then(({token}) => {
        console.log(token);
        onSuccess(token)
      })
      .catch((err) => {
        console.log(err);
        onError(err);
      })
  };

  render() {
    // TODO: add one var for validate stripe form 
    const {fields, stripeCardStatus} = this.state;
    const mainButtonClasses = classNames({
      'main-button': true,
      'disabled-button': stripeCardStatus !== TEXT_FIELD_STATUS.VALID,
    })
    return (
      <form onSubmit={this.handleSubmit}>
        <CardSection
          // for now - don't use react context coz using stripe
          nameTextField={fields[cardNameFieldName]}
          nameTextFieldName={cardNameFieldName}
          registerField={this.registerField}
          changeHandler={this.fieldChangeHandler}
          stripeCardStatusHandler={this.stripeCardStatusHandler}
          focusHandler={this.fieldFocusHandler}/>
          <div className="button-wrapper">
            <button disabled={stripeCardStatus === TEXT_FIELD_STATUS.INVALID} className={mainButtonClasses}>Add</button>
          </div>
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/StripeCard/components/InjectedCheckoutForm.js